
import { Box, Button, Modal } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetGroupsQuery } from '../groups/groupsApiSlice';
import TimeLeft from '../../partial/TimeLeft';
import { useExportTaskBasesToGroupMutation } from './taskBasesApiSlice';
import { useEffect, useState } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
const TaskBaseExporter = ({selected, setShowModal}) => {
    const navigate = useNavigate()
    const {id, groupId, type} = useParams()
    const [group, setGroup] = useState("")
    const [dt, setDt] =  useState(new Date(new Date().setDate(new Date().getDate() + 7)))

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })


    const [exportEvent, {isSuccess, data, error, isError}] = useExportTaskBasesToGroupMutation()
    useEffect(()=>{
        if(isSuccess){
           navigate(`/${type}/${group}/tasks`)
        }

    },[isSuccess])

    const handleClick = () => {
        if(!group) {
            alert("please select group")
            return
        }
        if(!selected?.length) {
            alert("please select task bases")
            return
        }
        exportEvent({selected, group, dt})
       
      };

    if (!groups) return <PulseLoader color={"#FFF"} />
    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })
    const errClass = (isError ) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message) ?? ''
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        setShowModal(false)
      };
  return (
    <Modal
  open={true}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 400 }}>
  <p className={errClass}>{errContent}</p>
  <div className="form-input-container">
    <div >
        <h1>שכפול משימות  </h1>
                 <label className="form__label form__title-row" htmlFor="dt">
                   <span> To Date:</span> <small > (<TimeLeft endtime={dt} />)</small> </label>
                <input
                    className={`form__input  ${!dt &&'form__input--incomplete'}`}
                    id="dt"
                    name="dt"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${dt.getFullYear().toString()}-${(dt.getMonth() + 1).toString().padStart(2, 0)}-${dt.getDate().toString().padStart(2, 0)}T${dt.getHours().toString().padStart(2, 0)}:${dt.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setDt(new Date(e.target.value))}
                />
                </div>
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="group">
                    קבוצת יעד לקבל את המשימות:</label>
                <select
                    id="group"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>setGroup(e.target.value)}
                >
                    <option>--קבוצת יעד למשימות--</option>
                    {options}
                </select>
                    </div>
                    </div>
                    <div className="buttons-pan">
                    <Button color="error" variant="contained" onClick={handleClose} >Close</Button>
                <Button variant="contained" onClick={handleClick} >Duplicate</Button>
                </div>
    
  </Box>
</Modal>
  )
}

export default TaskBaseExporter